<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <section class="tw:rounded-xl tw:border tw:border-zinc-200 tw:bg-white">
    <header class="tw:flex tw:flex-wrap tw:items-start tw:justify-between tw:gap-3 tw:border-b tw:border-zinc-100 tw:px-5 tw:py-4">
      <div class="tw:min-w-0 tw:flex-1 tw:basis-64">
        <h3 class="tw:m-0 tw:text-base tw:font-semibold">{{ title }}</h3>
        <p v-if="description" class="tw:mt-1 tw:mb-0 tw:text-sm tw:text-zinc-500">{{ description }}</p>
      </div>
      <slot name="aside" />
    </header>
    <slot />
  </section>
</template>
